import { Table } from 'semantic-ui-react';
import React from 'react';
import { TableRowNoDataFoundProps } from '../../interfaces/TableRowNoDataFoundProps';

export const TableRowNoDataFound = (props: TableRowNoDataFoundProps) => {
  return (
    <Table.Row className="no-data-found">
      <Table.Cell colSpan={props.colSpan} textAlign="center">
        <>
          {typeof props.errorText === 'string' && (
            <span dangerouslySetInnerHTML={{ __html: props.errorText }} />
          )}
          {typeof props.errorText !== 'string' && props.errorText}
        </>
      </Table.Cell>
    </Table.Row>
  );
};
